import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { useTranslation } from '@lt/localization';

import { FORTUNA_ASSETS } from 'src/constants/fortunaAssets';
import HintButton from '../../../../components/HintButton';
import { FORTUNA_TITLE, FORTUNA_SUBTITLE } from '../../../../constants/common';

const StyledWrapper = styled.div`
  ${({ url, url2x, url3x, isMobile }) =>
    !isMobile &&
    css`
      height: 400px;
      background-image: url(${url});
      background-position: 50% 0;
      background-size: contain;

      /** TODO: add autoprefixer */
      @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
        background-image: url(${url2x});
      }

      @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
        background-image: url(${url3x});
      }
    `}
`;

const StyledContainer = styled.div`
  margin: 0 auto;
  text-align: center;

  ${({ isMobile, theme }) =>
    !isMobile &&
    css`
      position: relative;
      top: 114px;
      display: flex;
      width: 629px;
      height: 172px;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: ${theme.colors.white};
    `}
`;

const StyledHeader = styled.div`
  ${({ theme }) => theme.typography.headline3};
  margin-bottom: 10px;

  ${({ isMobile, theme }) =>
    isMobile &&
    `
    color: ${theme.colors.blackLight};
    margin-left: 20px;
    margin-right: 20px;
  `}
`;

const StyledSubheader = styled.div`
  margin-bottom: 10px;
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '14px')};
  white-space: pre-line;
  color: ${({ theme }) => theme.colors.blackLight};

  ${({ isMobile }) =>
    isMobile &&
    `
    margin-left: 40px;
    margin-right: 40px;
  `}
`;

const StyledHintButton = styled(HintButton).attrs({
  dataAttr: 'text-hint',
  position: 'bottom',
})`
  font-size: ${({ isMobile }) => (isMobile ? '12px' : '13px')};
  color: ${({ theme }) => theme.colors.greyLight};
`;

const StyledImage = styled.div`
  margin-bottom: 10px;
  width: 100%;
  height: 120px;

  ${({ url, url2x, url3x, theme }) => css`
    background-color: ${theme.colors.white};
    background-image: url(${url});
    background-position: 50% 0;
    background-size: contain;

    @media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 2dppx) {
      background-image: url(${url2x});
    }

    @media (-webkit-min-device-pixel-ratio: 3), (min-resolution: 3dppx) {
      background-image: url(${url3x});
    }
  `}
`;

const FortunaJumbotron = ({ isMobile, tooltip }) => {
  const { t } = useTranslation();

  return (
    <StyledWrapper
      isMobile={isMobile}
      url={FORTUNA_ASSETS['hotels/fortuna.jpg']}
      url2x={FORTUNA_ASSETS['hotels/fortuna@2x.jpg']}
      url3x={FORTUNA_ASSETS['hotels/fortuna@3x.jpg']}
    >
      {isMobile && (
        <StyledImage
          url={FORTUNA_ASSETS['hotels/fortuna-mobile.jpg']}
          url2x={FORTUNA_ASSETS['hotels/fortuna-mobile@2x.jpg']}
          url3x={FORTUNA_ASSETS['hotels/fortuna-mobile@3x.jpg']}
        />
      )}
      <StyledContainer isMobile={isMobile}>
        <StyledHeader isMobile={isMobile}>{FORTUNA_TITLE}</StyledHeader>
        <StyledSubheader isMobile={isMobile}>
          {FORTUNA_SUBTITLE}
        </StyledSubheader>
        <StyledHintButton text={tooltip}>
          {t('checkout.extraRooms.more')}
        </StyledHintButton>
      </StyledContainer>
    </StyledWrapper>
  );
};

FortunaJumbotron.propTypes = {
  isMobile: PropTypes.bool,
  tooltip: PropTypes.string.isRequired,
};

FortunaJumbotron.defaultProps = {
  isMobile: false,
};

export default FortunaJumbotron;
